import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/Header/LanguageSwitcher';
import { demanderReinitialisation } from './motDePasse.api';

// Le message du proxy est affiché tel quel : l'écran ne branche jamais sur la
// raison d'un refus (anti-énumération côté Odoo).
const messageDErreur = (err, t) => {
  const status = err?.response?.status;
  const message = err?.response?.data?.message;
  if (status === 429) return t('motDePasseOublie.tropDeDemandes');
  if (status === 400 && typeof message === 'string') return message;
  return t('motDePasseOublie.erreurTechnique');
};

const MotDePasseOublie = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [country, setCountry] = useState(null);
  const [login, setLogin] = useState(location.state?.login || '');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState('');
  const [confirmation, setConfirmation] = useState('');

  useEffect(() => {
    const code = localStorage.getItem('selectedCountryCode');
    if (!code) {
      navigate('/countryselect', { replace: true, state: location.state });
      return;
    }
    setCountry(code);
  }, [location.state, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (envoi) return;
    if (!login.trim()) {
      setErreur(t('motDePasseOublie.champRequis'));
      return;
    }
    setEnvoi(true);
    setErreur('');
    try {
      const data = await demanderReinitialisation(login.trim(), country);
      if (data?.ok === true) {
        setConfirmation(data.message);
      } else {
        setErreur(typeof data?.message === 'string' ? data.message : t('motDePasseOublie.erreurTechnique'));
      }
    } catch (err) {
      setErreur(messageDErreur(err, t));
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center p-8 min-h-screen bg-gradient-to-br from-blue-50 to-orange-50">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg rounded-xl p-8">
          <div className="flex items-center justify-between mb-4">
            <a href="/" className="text-4xl text-[--color-primary] font-extrabold inline-flex items-center">
              YROS
            </a>
            <LanguageSwitcher />
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('motDePasseOublie.titre')}</h2>

          {confirmation ? (
            <div className="space-y-6">
              <div className="p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded">{confirmation}</div>
              <Link to="/login" className="block text-center text-[--color-primary] hover:underline">
                {t('motDePasseOublie.retourConnexion')}
              </Link>
            </div>
          ) : (
            <>
              <p className="text-gray-600 mb-6">{t('motDePasseOublie.consigne')}</p>
              {erreur && (
                <div role="alert" className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
                  {erreur}
                </div>
              )}
              <form onSubmit={handleSubmit} noValidate className="space-y-6">
                <div>
                  <label htmlFor="formIdentifiant" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('motDePasseOublie.identifiantLabel')}
                  </label>
                  <input
                    type="email"
                    id="formIdentifiant"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    className="block w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition-all"
                    placeholder={t('login.emailPlaceholder')}
                  />
                </div>
                <button
                  type="submit"
                  disabled={envoi}
                  className="w-full bg-[--color-primary] hover:bg-[--color-orange] text-white py-3 px-4 rounded-lg font-medium transition-all shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {t('motDePasseOublie.envoyer')}
                </button>
                <Link to="/login" className="block text-center text-sm text-[--color-primary] hover:underline">
                  {t('motDePasseOublie.retourConnexion')}
                </Link>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MotDePasseOublie;
